import Vue from 'vue'
import VueRouter from 'vue-router'
import { setupDynamicRoutes } from '@/utils/dynamicRouter'
import { getAllMenuDataAPI } from '@/api/system'

Vue.use(VueRouter)

// 动态路由加载状态
let dynamicRoutesLoaded = false
let dynamicRoutesLoading = false

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/Login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home/Home.vue'),
    meta: { requiresAuth: true } // 添加meta字段表示需要验证token
  },
  {
    path: '/clientele',
    name: 'clientele',
    component: () => import('@/views/Clientele/Clientele.vue'),
    meta: { requiresAuth: true, label: '客户管理' },
    redirect: '/clientele/file',
    children: [
      {
        path: 'add',
        name: 'clienteleAdd',
        component: () => import('@/views/Clientele/views/ClienteleAdd.vue')
      },
      {
        path: 'edit',
        name: 'clienteleEdit',
        component: () => import('@/views/Clientele/views/ClienteleEdit.vue'),
        props: true
      },
      {
        path: 'file',
        name: 'clienteleFile',
        component: () => import('@/views/Clientele/views/ClienteleFile.vue')
      }
    ]
  },
  {
    path: '/cases',
    name: 'cases',
    component: () => import('@/views/Cases/Cases.vue'),
    meta: { requiresAuth: true, label: '案源管理' },
    redirect: '/cases/report',
    children: [
      {
        path: 'report',
        name: 'casesReport',
        redirect: '/cases/report/table',
        meta: { label: '案源报备' },
        component: () => import('@/views/Cases/views/CasesReport.vue'),
        children: [
          {
            path: 'add',
            name: 'casesReportAdd',
            component: () => import('@/views/Cases/views/CasesReportAdd.vue')
          },
          {
            path: 'table',
            name: 'casesReportTable',
            component: () => import('@/views/Cases/views/CaseReportTable.vue')
          }
        ]
      },
      {
        path: 'pending',
        name: 'casesPending',
        component: () => import('@/views/Cases/views/CasesPending.vue')
      },
      {
        path: 'jleanlist',
        name: 'casesJleanlist',
        component: () => import('@/views/Cases/views/CasesTake.vue')
      },
      {
        path: 'total',
        name: 'casesTotal',
        component: () => import('@/views/Cases/views/CasesTotal.vue')
      }
    ]
  },
  {
    path: '/ajgl',
    name: 'ajgl',
    component: () => import('@/views/Cases/Cases.vue'),
    meta: { requiresAuth: true, label: '案管中心' },
    redirect: '/ajgl/aglist',
    children: [
      {
        path: 'aglist',
        name: 'aglist',
        meta: { label: '待审批列表' },
        component: () => import('@/views/Cases/views/Caseaglist.vue')
      },
      {
        path: 'total',
        name: 'ajglTotal',
        meta: { label: '接案总计' },
        component: () => import('@/views/Cases/views/AjglTotal.vue')
      }
    ]
  },
  {
    path: '/casemanagement',
    name: 'casemanagement',
    component: () => import('@/views/CaseManagement/Managemnt.vue'),
    meta: { requiresAuth: true, label: '案件管理' },
    redirect: '/casemanagement/progress',
    children: [
      {
        path: 'progress',
        name: 'progress',
        meta: { label: '诉讼在办' },
        component: () => import('@/views/CaseManagement/progress'),
        redirect: '/casemanagement/progress/beforlitigation',
        children: [
          {
            path: 'beforlitigation',
            name: 'beforlitigation',
            component: () =>
              import('@/views/CaseManagement/progress/BeforLitigation')
          },
          {
            path: 'lawsuit',
            name: 'lawsuit',
            component: () => import('@/views/CaseManagement/progress/Lawsuit')
          },
          {
            path: 'caseanomaly',
            name: 'caseanomaly',
            component: () =>
              import('@/views/CaseManagement/progress/Caseanomaly')
          },
          {
            path: 'carryout',
            name: 'carryout',
            component: () => import('@/views/CaseManagement/progress/caseload')
          },
          {
            path: 'holdcourt',
            name: 'holdcourt',
            component: () => import('@/views/CaseManagement/progress/holdcourt')
          }
        ]
      },
      {
        path: 'execute',
        name: 'execute',
        meta: { label: '执行在办' },
        component: () => import('@/views/CaseManagement/execute'),
        redirect: '/casemanagement/execute/prepare',
        children: [
          {
            path: 'prepare',
            name: 'prepare',
            component: () => import('@/views/CaseManagement/execute/prepare')
          },
          {
            path: 'progress',
            name: 'progress',
            component: () => import('@/views/CaseManagement/execute/progress')
          },
          {
            path: 'abnormal',
            name: 'abnormal',
            component: () => import('@/views/CaseManagement/execute/abnormal')
          }
         
        ]
      },
      {
        path: 'withdrawcase',
        name: 'withdrawcase',
        meta: { label: '退案列表' },
        component: () => import('@/views/CaseManagement/Withdrawcase')
      }
    ]
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('@/views/Finance/Finance.vue'),
    meta: { requiresAuth: true, label: '财务管理' },
    redirect: '/finance/handling',
    children: [
      {
        path: 'handling',
        name: 'financeHandling',
        meta: { label: '办案费用' },
        redirect: '/finance/handling/receivables',
        component: () => import('@/views/Finance/handling'),
        children: [
          {
            path: 'receivables',
            name: 'financeHandlingReceivables',
            meta: { label: '应收监管表' },
            component: () => import('@/views/Finance/handling/receivables')
          },
          {
            path: 'advance',
            name: 'financeHandlingAdvance',
            meta: { label: '办公费用垫付表' },
            component: () => import('@/views/Finance/handling/advance')
          }
        ]
      },
      {
        path: 'everyday',
        name: 'financeEveryday',
        meta: { label: '日常费用' },
        redirect: '/finance/everyday/borrowing',
        component: () => import('@/views/Finance/everyday'),
        children: [
          {
            path: 'borrowing',
            name: 'financeEverydayBorrowing',
            meta: { label: '借/支列表' },
            component: () => import('@/views/Finance/everyday/borrowing'),
            redirect: '/finance/everyday/borrowing/borrow',
            children: [
              {
                path: 'borrow',
                name: 'financeEverydayBorrowingBorrow',
                meta: { label: '借支申请单' },
                component: () =>
                  import('@/views/Finance/everyday/borrowing/borrow')
              },
              {
                path: 'expenditure',
                name: 'financeEverydayBorrowingExpenditure',
                meta: { label: '支出证明单' },
                component: () =>
                  import('@/views/Finance/everyday/borrowing/expenditure')
              }
            ]
          },
          {
            path: 'reimbursement',
            name: 'financeEverydayReimbursement',
            meta: { label: '报销管理' },
            component: () => import('@/views/Finance/everyday/reimbursement')
          },
          {
            path: 'invoice',
            name: 'financeEverydayInvoice',
            meta: { label: '发票管理' },
            component: () => import('@/views/Finance/everyday/invoice')
          }
        ]
      },
      {
        path: 'selfowned',
        name: 'financeSelfowned',
        meta: { label: '自有案件' },
        component: () => import('@/views/Finance/selfowned')
      },
      {
        path: 'proceeds',
        name: 'financeProceeds',
        meta: { label: '结案收款' },
        component: () => import('@/views/Finance/proceeds')
      },
      {
        path: 'file',
        name: 'financeFile',
        meta: { label: '结案归档' },
        component: () => import('@/views/Finance/file')
      },
      {
        path: 'sendback',
        name: 'financeSendback',
        meta: { label: '退案列表' },
        component: () => import('@/views/Finance/sendback')
      }
    ]
  },
  {
    path: '/personnel',
    name: 'personnel',
    component: () => import('@/views/Personnel/Personnel.vue'),
    meta: { requiresAuth: true, label: '人事管理' },
    redirect: '/personnel/jobmanagement',
    children: [
      {
        path: 'jobmanagement',
        name: 'personnelJobmanagement',
        meta: { label: '在职管理' },
        component: () => import('@/views/Personnel/jobmanagement'),
        redirect: '/personnel/jobmanagement/overview',
        children: [
          {
            path: 'overview',
            name: 'personnelJobmanagementOverview',
            component: () => import('@/views/Personnel/jobmanagement/overview')
          },
          {
            path: 'attendance',
            name: 'personnelJobmanagementAttendance',
            component: () =>
              import('@/views/Personnel/jobmanagement/attendance')
          },
          {
            path: 'leave',
            name: 'personnelJobmanagementLeave',
            component: () => import('@/views/Personnel/jobmanagement/leave')
          },
          {
            path: 'salary',
            name: 'personnelJobmanagementSalary',
            component: () => import('@/views/Personnel/jobmanagement/salary')
          },
          {
            path: 'position',
            name: 'personnelJobmanagementPosition',
            component: () => import('@/views/Personnel/jobmanagement/position')
          },
          {
            path: 'trip',
            name: 'personnelJobmanagementTrip',
            component: () => import('@/views/Personnel/jobmanagement/trip')
          }
        ]
      },
      {
        path: 'dimissionmanagement',
        name: 'personnelDimissionManagement',
        meta: { label: '离职管理' },
        component: () => import('@/views/Personnel/dimissionmanagement'),
        redirect: '/personnel/dimissionmanagement/dimissionlist',
        children: [
          {
            path: 'dimissionlist',
            name: 'personnelDimissionManagementDimissionList',
            meta: { label: '离职列表' },
            component: () =>
              import('@/views/Personnel/dimissionmanagement/dimissionlist')
          },
          {
            path: 'dimissionapplication',
            name: 'personnelDimissionManagementDimissionApplication',
            meta: { label: '离职申请' },
            component: () =>
              import(
                '@/views/Personnel/dimissionmanagement/dimissionapplication'
              )
          }
        ]
      },
      {
        path: 'permission',
        name: 'personnelPermission',
        component: () => import('@/views/System/views/Permission.vue'),
        meta: { 
          label: '部门管理',
          beforeEnter(to, from, next) {
            // 检查是否是权限管理相关的路径，如果是则加载对应的菜单数据
            if (to.path.startsWith('/personnel/permission')) {
              setTimeout(() => {
                if (window.app && window.app.$store) {
                  window.app.$store.dispatch('m_tabs/asyncGetAsideTabMenuData', 164)
                }
              }, 100)
            }
            next()
          }
        },
        redirect: '/personnel/permission/department',
        children: [
          {
            path: 'department',
            name: 'personnelPermissionDepartment',
            component: () => import('@/views/System/views/department/index.vue')
          },
          {
            path: 'industry',
            name: 'personnelPermissionIndustry',
            component: () => import('@/views/System/views/industry/index.vue')
          },
          {
            path: 'jobrank',
            name: 'personnelPermissionJobRank',
            component: () => import('@/views/System/views/jobrank/index.vue')
          },
          {
            path: 'approvaltype',
            name: 'personnelPermissionApprovalType',
            component: () => import('@/views/System/views/approvaltype/index.vue')
          },
          { path: 'approvalprocess',
            name: 'personnelPermissionApprovalProcess',
            component: () =>
              import('@/views/System/views/approvalprocess/index.vue')
          },
          { path: 'jobtitle',
            name: 'personnelPermissionJobTitle',
            component: () => import('@/views/System/views/jobtitle/index.vue')
          },
          { path: 'casetype',
            name: 'personnelPermissionCaseType',
            component: () => import('@/views/System/views/casetype/index.vue')
          },
          { path: 'casesource',
            name: 'personnelPermissionCaseSource',
            component: () => import('@/views/System/views/casesource/index.vue')
          },
          { path: 'userpermission',
            name: 'personnelPermissionUserPermission',
            component: () => import('@/views/System/views/userpermission/index.vue')
          },
          { path: 'rule',
            name: 'personnelPermissionRule',
            component: () => import('@/views/System/views/rule/index.vue')
          }
        ]
      }
    ]
  },
  {
    path: '/synthesis',
    name: 'synthesis',
    component: () => import('@/views/Synthesis/Synthesis.vue'),
    meta: { requiresAuth: true, label: '综合管理' },
    redirect: '/synthesis/worktask',
    children: [
      {
        path: 'worktask',
        name: 'synthesisWorktask',
        meta: { label: '工作任务' },
        component: () => import('@/views/Synthesis/worktask'),
        redirect: '/synthesis/worktask/assignment',
        children: [
          {
            path: 'assignment',
            name: 'synthesisWorktaskAssignment',
            meta: { label: '任务发布' },
            component: () => import('@/views/Synthesis/worktask/assignment'),
            redirect: '/synthesis/worktask/assignment/detail',
            children: [
              {
                path: 'detail',
                name: 'synthesisWorktaskAssignmentDetail',
                meta: { label: '任务详情' },
                component: () =>
                  import('@/views/Synthesis/worktask/assignment/detail')
              },
              {
                path: 'add',
                name: 'synthesisWorktaskAssignmentAdd',
                meta: { label: '新建任务' },
                component: () =>
                  import('@/views/Synthesis/worktask/assignment/add')
              }
            ]
          },
          {
            path: 'summarylist',
            name: 'synthesisWorktaskSummaryList',
            meta: { label: '日报/总结列表' },
            component: () => import('@/views/Synthesis/worktask/summarylist')
          },
          {
            path: 'summaryfillout',
            name: 'synthesisWorktaskSummaryFillout',
            meta: { label: '日报/总结填写' },
            component: () =>
              import('@/views/Synthesis/worktask/summaryfillout'),
            redirect: '/synthesis/worktask/summaryfillout/daily',
            children: [
              {
                path: 'daily',
                name: 'synthesisWorktaSksummaryFilloutDaily',
                meta: { label: '日报' },
                component: () =>
                  import('@/views/Synthesis/worktask/summaryfillout/daily')
              },
              {
                path: 'summarize',
                name: 'synthesisWorktaSksummaryFilloutSummarize',
                meta: { label: '总结' },
                component: () =>
                  import('@/views/Synthesis/worktask/summaryfillout/summarize')
              }
            ]
          }
        ]
      },
      {
        path: 'form',
        name: 'synthesisForm',
        meta: { label: '表单管理' },
        component: () => import('@/views/Synthesis/form'),
        redirect: '/synthesis/form/datas',
        children: [
          {
            path: 'datas',
            name: 'synthesisFormDatas',
            meta: { label: '合同、文件、资料' },
            component: () => import('@/views/Synthesis/form/datas')
          }
        ]
      },
      {
        path: 'learn',
        name: 'synthesisLearn',
        meta: { label: '学习培训' },
        component: () => import('@/views/Synthesis/learn'),
        redirect: '/synthesis/learn/datas',
        children: [
          {
            path: 'datas',
            name: 'synthesisLearnDatas',
            meta: { label: '学习资料' },
            component: () => import('@/views/Synthesis/learn/datas')
          }
        ]
      },
      {
        path: 'systemdocument',
        name: 'synthesisSystemdocument',
        meta: { label: '制度文件' },
        component: () => import('@/views/Synthesis/systemdocument'),
        redirect: '/synthesis/systemdocument/inform',
        children: [
          {
            path: 'inform',
            name: 'synthesisSystemdocumentInform',
            meta: { label: '律所制度文件、通知' },
            component: () => import('@/views/Synthesis/systemdocument/inform')
          }
        ]
      },
      {
        path: 'punishment',
        name: 'synthesisPunishment',
        meta: { label: '处罚通知' },
        component: () => import('@/views/Synthesis/punishment'),
        redirect: '/synthesis/punishment/list',
        children: [
          {
            path: 'list',
            name: 'synthesisPunishmentList',
            meta: { label: '处罚通知列表' },
            component: () => import('@/views/Synthesis/punishment/list')
          }
        ]
      },
      {
        path: 'evidence',
        name: 'synthesisEvidence',
        meta: { label: '证据领用' },
        component: () => import('@/views/Synthesis/evidence'),
        redirect: '/synthesis/evidence/storage',
        children: [
          {
            path: 'storage',
            name: 'synthesisEvidenceStorage',
            meta: { label: '证据列表' },
            component: () => import('@/views/Synthesis/evidence/storage')
          }
        ]
      },
      {
        path: 'expressage',
        name: 'synthesisExpressage',
        meta: { label: '快递收发' },
        component: () => import('@/views/Synthesis/expressage'),
        redirect: '/synthesis/expressage/list',
        children: [
          {
            path: 'list',
            name: 'synthesisExpressageList',
            meta: { label: '收/发列表' },
            component: () => import('@/views/Synthesis/expressage/list'),
            redirect: '/synthesis/expressage/list/receive',
            children: [
              {
                path: 'receive',
                name: 'synthesisExpressageListReceive',
                meta: { label: '收件列表' },
                component: () =>
                  import('@/views/Synthesis/expressage/list/receive')
              },
              {
                path: 'send',
                name: 'synthesisExpressageListSend',
                meta: { label: '发件列表' },
                component: () =>
                  import('@/views/Synthesis/expressage/list/send')
              }
            ]
          }
        ]
      },
      {
        path: 'property',
        name: 'synthesisProperty',
        meta: { label: '资产管理' },
        component: () => import('@/views/Synthesis/property'),
        redirect: '/synthesis/property/materials',
        children: [
          {
            path: 'materials',
            name: 'synthesisPropertyMaterials',
            meta: { label: '收/发列表' },
            component: () => import('@/views/Synthesis/property/materials'),
            redirect: '/synthesis/property/materials/goods',
            children: [
              {
                path: 'goods',
                name: 'synthesisPropertyMaterialsGoods',
                meta: { label: '物品物资领用登记表' },
                component: () =>
                  import('@/views/Synthesis/property/materials/goods')
              },
              {
                path: 'gift',
                name: 'synthesisPropertyMaterialsGift',
                meta: { label: '礼品领用品领用登记表' },
                component: () =>
                  import('@/views/Synthesis/property/materials/gift')
              },
              {
                path: 'work',
                name: 'synthesisPropertyMaterialsWork',
                meta: { label: '办公用品领用登记表' },
                component: () =>
                  import('@/views/Synthesis/property/materials/work')
              }
            ]
          },
          {
            path: 'soft',
            name: 'synthesisPropertySoft',
            meta: { label: '软装资产' },
            component: () => import('@/views/Synthesis/property/soft')
          },
          {
            path: 'hard',
            name: 'synthesisPropertyHard',
            meta: { label: '硬装资产' },
            component: () => import('@/views/Synthesis/property/hard')
          },
          {
            path: 'wholesale',
            name: 'synthesisPropertyWholesale',
            meta: { label: '大额资产采购' },
            component: () => import('@/views/Synthesis/property/wholesale')
          }
        ]
      },
      {
        path: 'badge',
        name: 'synthesisbadge',
        meta: { label: '证章申领' },
        component: () => import('@/views/Synthesis/badge'),
        redirect: '/synthesis/badge/apply',
        children: [
          {
            path: 'apply',
            name: 'synthesisBadgeApply',
            meta: { label: '证、章申领' },
            component: () => import('@/views/Synthesis/badge/apply')
          }
        ]
      },
      {
        path: 'procedure',
        name: 'synthesisProcedure',
        meta: { label: '手续费用申领' },
        component: () => import('@/views/Synthesis/procedure'),
        redirect: '/synthesis/procedure/recommendation',
        children: [
          {
            path: 'recommendation',
            name: 'synthesisProcedureRecommendation',
            meta: { label: '介绍信领取' },
            component: () =>
              import('@/views/Synthesis/procedure/recommendation'),
            redirect: '/synthesis/procedure/recommendation/civil',
            children: [
              {
                path: 'civil',
                name: 'synthesisProcedureRecommendationCivil',
                meta: { label: '民事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/recommendation/civil')
              },
              {
                path: 'penal',
                name: 'synthesisProcedureRecommendationPenal',
                meta: { label: '刑事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/recommendation/penal')
              }
            ]
          },
          {
            path: 'missive',
            name: 'synthesisProcedureMissive',
            meta: { label: '公函领取' },
            component: () => import('@/views/Synthesis/procedure/missive'),
            redirect: '/synthesis/procedure/missive/civil',
            children: [
              {
                path: 'civil',
                name: 'synthesisProcedureMissiveCivil',
                meta: { label: '民事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/missive/civil')
              },
              {
                path: 'penal',
                name: 'synthesisProcedureMissivePenal',
                meta: { label: '刑事介绍信领取登记表' },
                component: () =>
                  import('@/views/Synthesis/procedure/missive/penal')
              }
            ]
          },
          {
            path: 'selfowned',
            name: 'synthesisProcedureSelfowned',
            meta: { label: '自有业务领款函' },
            component: () => import('@/views/Synthesis/procedure/selfowned')
          }
        ]
      }
    ]
  },
  
      
     
    

  {
    path: '/realty',
    name: 'realty',
    component: () => import('@/views/Realty/Realty.vue'),
    meta: { requiresAuth: true, label: '房地产建筑企业档案' },
    redirect: '/realty/construction',
    children: [
      {
        path: 'construction',
        name: 'realtyConstruction',
        meta: { label: '管理员账户' },
        component: () => import('@/views/Realty/construction')
      }
    ]
  },
  {
    path: '/selfowned',
    name: 'selfowned',
    component: () => import('@/views/SelfOwned/SelfOwned.vue'),
    meta: { requiresAuth: true, label: '自有案件' },
    redirect: '/selfowned/caselist',
    children: [
      {
        path: 'caselist',
        name: 'selfownedCaselist',
        meta: { label: '案件列表' },
        component: () => import('@/views/SelfOwned/caselist')
      },
      {
        path: 'closing',
        name: 'selfownedClosing',
        meta: { label: '结案归档' },
        component: () => import('@/views/SelfOwned/closing')
      },
      {
        path: 'closing2',
        name: 'selfownedClosing2',
        meta: { label: '结案归档2' },
        component: () => import('@/views/SelfOwned/closing')
      },
    ]
  },
  {
    path: '/system',
    name: 'system',
    component: () => import('@/views/System/System.vue'),
    meta: { requiresAuth: true, label: '系统管理' },
    children: [
      {
        path: 'admin',
        name: 'systemAdmin',
        meta: { label: '管理员账号' },
        component: () => import('@/views/System/views/SystemAdmin.vue')
      },
      {
        path: 'person',
        name: 'systemPerson',
        meta: { label: '员工账号' },
        component: () => import('@/views/System/views/SystemPerson.vue')
      },
      {
        path: 'customer',
        name: 'systemCustomer',
        meta: { label: '客户账号' },
        component: () => import('@/views/System/views/SystemCustomer.vue')
      },
      {
        path: 'logs',
        name: 'systemLogs',
        meta: { label: '操作日志' },
        component: () => import('@/views/System/views/OperationLogs.vue')
      },
      {
        path: 'role',
        name: 'systemRole',
        meta: { label: '角色管理' },
        component: () => import('@/views/System/views/SystemRole.vue')
      },
      {
        path: 'department',
        name: 'systemDepartment',
        meta: { label: '部门管理' },
        component: () => import('@/views/System/views/SystemDepartment.vue')  
      },
      {
        path: 'position',
        name: 'systemPosition',
        meta: { label: '岗位职称' },
        component: () => import('@/views/System/views/SystemPosition.vue')  
      },
      {
        path: 'industry',
        name: 'systemIndustry',
        meta: { label: '行业管理' },
        component: () => import('@/views/System/views/industry/index.vue')
      },
      {
        path: 'casetype',
        name: 'systemCaseType',
        meta: { label: '案件类型' },
        component: () => import('@/views/System/views/casetype/index.vue')
      },
      {
        path: 'casesource',
        name: 'systemCaseSource',
        meta: { label: '案源类型' },
        component: () => import('@/views/System/views/casesource/index.vue')
      },
      {
        path: 'approvalprocess',
        name: 'systemApprovalProcess',
        meta: { label: '审批流程' },
        component: () => import('@/views/System/views/approvalprocess/index.vue')
      },
      {
        path: 'jobLevel',
        name: 'systemJobRank',
        meta: { label: '岗位职级' },
        component: () => import('@/views/System/views/jobrank/index.vue')
      },
      {
        path: 'jobrank',
        name: 'systemJobRankNode',
        meta: { label: '功能节点' },
        component: () => import('@/views/System/views/SystemNode.vue')
      },
      {
        path: 'permissions',
        name: 'systemPermissions',
        meta: {label: '权限管理'},
        component: () => import('@/views/System/views/permissions/index.vue')
      }
    ]
  }
]

// 创建Vue Router实例
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 加载动态路由的函数
async function loadDynamicRoutes() {
  if (dynamicRoutesLoaded || dynamicRoutesLoading) {
    return false
  }
  
  dynamicRoutesLoading = true
  console.log('开始加载动态路由...')
  
  try {
    // 获取菜单数据的函数
    const fetchMenuData = async () => {
      try {
        console.log('开始获取菜单数据...')
        const response = await getAllMenuDataAPI()
        console.log('API原始响应:', response)
        
        // 步骤1: 提取数据
        let extractedData = response
        
        // 情况1: response是Axios响应对象，提取data
        if (response && typeof response === 'object' && response.data !== undefined) {
          extractedData = response.data
          console.log('从Axios响应中提取data:', extractedData)
        }
        
        // 步骤2: 转换为数组
        let finalArray = null
        
        // 情况2: 已经是数组
        if (Array.isArray(extractedData)) {
          finalArray = extractedData
          console.log('数据已经是数组，长度:', finalArray.length)
        }
        // 情况3: 是对象，且有数字键（如用户提供的示例）
        else if (extractedData && typeof extractedData === 'object') {
          const keys = Object.keys(extractedData)
          console.log('数据对象键:', keys)
          
          // 检查是否有数字键
          const numericKeys = keys.filter(key => {
            const num = parseInt(key)
            return !isNaN(num) && String(num) === key && num >= 0
          })
          
          if (numericKeys.length > 0) {
            // 按数字顺序排序并转换为数组
            finalArray = numericKeys
              .sort((a, b) => parseInt(a) - parseInt(b))
              .map(key => extractedData[key])
            console.log('将数字键对象转换为数组，长度:', finalArray.length)
          }
          // 情况4: 有list字段
          else if (extractedData.list && Array.isArray(extractedData.list)) {
            finalArray = extractedData.list
            console.log('从list字段提取数组，长度:', finalArray.length)
          }
          // 情况5: 有data字段且为数组
          else if (extractedData.data && Array.isArray(extractedData.data)) {
            finalArray = extractedData.data
            console.log('从data字段提取数组，长度:', finalArray.length)
          }
          // 情况6: 有code和data字段，且data为数组
          else if (extractedData.code === 200 && extractedData.data && Array.isArray(extractedData.data)) {
            finalArray = extractedData.data
            console.log('从code/data字段提取数组，长度:', finalArray.length)
          }
        }
        
        if (!finalArray) {
          console.error('无法从响应中提取数组数据，响应结构:', extractedData)
          throw new Error('无法提取菜单数据，响应格式不支持')
        }
        
        if (finalArray.length === 0) {
          console.warn('菜单数据数组为空')
        } else {
          console.log('最终菜单数据数组长度:', finalArray.length, '，第一条数据:', finalArray[0])
        }
        
        return finalArray
      } catch (error) {
        console.error('获取菜单数据时发生错误:', error)
        throw error
      }
    }
    
    // 配置选项
    const options = {
      filterOptions: {
        onlyMenu: true, // 只包含菜单节点
        minStatus: 1    // 状态正常的节点
      },
      staticRoutes: [], // 不添加额外的静态路由
      onSuccess: (routes) => {
        console.log('动态路由加载成功，共生成', routes.length, '个路由')
        dynamicRoutesLoaded = true
      },
      onError: (error) => {
        console.error('动态路由加载失败:', error)
        // 即使动态路由加载失败，也允许继续使用静态路由
      }
    }
    
    // 初始化动态路由
    const success = await setupDynamicRoutes(router, fetchMenuData, options)
    
    if (success) {
      console.log('动态路由初始化完成')
    } else {
      console.warn('动态路由初始化失败，将使用静态路由')
    }
    
    return success
  } catch (error) {
    console.error('加载动态路由时发生错误:', error)
    return false
  } finally {
    dynamicRoutesLoading = false
  }
}

// 添加全局前置守卫
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token')
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要验证token的路由
    if (token) {
      // 登录后，加载动态路由（仅加载一次）
      if (!dynamicRoutesLoaded && !dynamicRoutesLoading) {
        // 不等待动态路由加载完成，避免阻塞导航
        loadDynamicRoutes().catch(err => {
          console.error('动态路由加载异常:', err)
        })
      }
      
      if (to.name === 'clienteleEdit' && from.name === null) {
        next({ name: 'clienteleFile' })
        return
      }
      
      // 检查是否是权限管理相关的路径，如果是则加载对应的菜单数据
      if (to.path.startsWith('/personnel/permission')) {
        // 检查当前菜单数据是否已经是权限管理的，避免重复加载
        const currentMenu = window.app?.$store?.state?.m_tabs?.asideTabMenu;
        const hasPermissionMenu = currentMenu && currentMenu.some(item => item.title === '权限管理');
        
        if (!hasPermissionMenu) {
          setTimeout(() => {
            if (window.app && window.app.$store) {
              window.app.$store.dispatch('m_tabs/asyncGetAsideTabMenuData', 164)
            }
          }, 100)
        }
      }
      
      // 检查是否是系统管理相关的路径，如果是则加载对应的菜单数据
      if (to.path.startsWith('/system')) {
        // 检查当前菜单数据是否已经是系统管理的，避免重复加载
        const currentMenu = window.app?.$store?.state?.m_tabs?.asideTabMenu;
        const hasSystemMenu = currentMenu && currentMenu.some(item => item.title === '系统管理');
        
        if (!hasSystemMenu) {
          setTimeout(() => {
            if (window.app && window.app.$store) {
              // 尝试使用系统管理的pid，可能需要根据实际情况调整
              window.app.$store.dispatch('m_tabs/asyncGetAsideTabMenuData', 133)
            }
          }, 100)
        }
      }
      
      // 有token，允许导航到目标路由
      next()
    } else {
      // 没有token，重定向到登录页面
      next('/login')
    }
  } else {
    // 不需要验证token的路由，直接允许导航
    next()
  }
})

export default router
